import {
  polyfill
} from 'es6-promise';
polyfill();

import Vue from 'vue';
import FilterApp from './FilterApp.vue';
import router from './router/index.js';
import store from './store/index.js';
import { mapActions, mapState } from 'vuex';

let userAgent, ieReg, ie11;
userAgent = window.navigator.userAgent;
ieReg = /msie|Trident.*rv[ :]*11\./gi;
ie11 = ieReg.test(userAgent);

if (ie11) {
  let footer = document.getElementById("footer");
  if (footer) {
    footer.classList.add('utility-hidden');
  }
}

// Vue Instance
const rootMenu = document.getElementById('find-a-therapist');
if (rootMenu) {
  new Vue({
    el: '#find-a-therapist',
    mounted: function () {

      //Put all search criteria into vuex store 
      const culturalExperienceJSON = JSON.parse(document.getElementById('cultural-experience-data').innerHTML);
      const genderJSON = JSON.parse(document.getElementById('gender-data').innerHTML);
      const languageJSON = JSON.parse(document.getElementById('language-data').innerHTML);
      const locationJSON = JSON.parse(document.getElementById('location-data').innerHTML);
      const therapistExperienceJSON = JSON.parse(document.getElementById('therapist-experience-data').innerHTML);

      if (locationJSON) {
        this.$store.dispatch('initLocationData', { locationJSON });
      }
      if (genderJSON) {
        this.$store.dispatch('initGenderData', { genderJSON });
      }
      if (languageJSON) {
        this.$store.dispatch('initLanguageData', { languageJSON });
      }
      if (therapistExperienceJSON) {
        this.$store.dispatch('initTherapistExperienceData', { therapistExperienceJSON });
      }
      if (culturalExperienceJSON) {
        this.$store.dispatch('initCulturalExperienceData', { culturalExperienceJSON });
      }

      let QsParams = '';

      if (Object.entries(this.$route.query).length === 0) {
        this.$store.dispatch('UpdateShowNoResultsText', false);
      } else {
        this.$store.state.loading = true;
        QsParams = Object.keys(this.$route.query).map(key => key + '=' + this.$route.query[key]).join('&');
        this.$store.dispatch('APICallWithQsParams', QsParams);
        this.$store.dispatch('UpdateShowResultsCountText', true);
        this.$store.dispatch('UpdateShowNoResultsText', true);
      }
    },
    store: store,
    router,
    methods: {
      ...mapActions({
        APICall: 'APICall',
        applyFiltersToAPICall: 'applyFiltersToAPICall',
        applyPagination: 'applyPagination',
        clearAllFilters: 'clearAllFilters',
        deleteSubRegions: 'deleteSubRegions',
        removeFilterFromButton: 'removeFilterFromButton',
        updateFilterFromButton: 'updateFilterFromButton',
        updateRegion: 'updateRegion',
        updateShowOptions: 'updateShowOptions',
        updateSubRegions: 'updateSubRegions'
      })
    },
    computed: {
      ...mapState([
        'subRegionsForRegion',
        'selectedSubregions'
      ])
    },
    data: function () {
      return {
        applyFiltersText: null,
        clearFiltersText: null,
        culturalExperienceData: null,
        enableSupplierFocusedSearch: null,
        genderData: null,
        languageData: null,
        loading: null,
        locationData: null,
        noResultsText: null,
        resultsExplainerText: null,
        resultsTab1Text: null,
        resultsTab2Text: null,
        response: null,
        therapistExperienceData: null,
      }
    },
    created: function () {
      this.applyFiltersText = "Apply filters";
      this.clearFiltersText = "Clear filters";
      this.culturalExperienceData = JSON.parse(document.getElementById('cultural-experience-data').innerHTML);
      this.enableSupplierFocusedSearch = Boolean(JSON.parse(document.getElementById('enable-supplier-search').innerHTML));
      this.genderData = JSON.parse(document.getElementById('gender-data').innerHTML);
      this.loading = false;
      this.locationData = JSON.parse(document.getElementById('location-data').innerHTML);
      this.languageData = JSON.parse(document.getElementById('language-data').innerHTML);
      this.noResultsText = document.getElementById('no-results-text').innerHTML;
      this.response = {};
      this.resultsExplainerText = document.getElementById('results-explainer-text').innerHTML;
      this.resultsTab1Text = document.getElementById('results-tab-1-text').innerHTML;
      this.resultsTab2Text = document.getElementById('results-tab-2-text').innerHTML;
      this.therapistExperienceData = JSON.parse(document.getElementById('therapist-experience-data').innerHTML);
    },
    render: function render(h) {
      return h(FilterApp, {
        props: {
          //actions
          APICall: this.APICall,
          deleteSubRegions: this.deleteSubRegions,
          updateFilterFromButton: this.updateFilterFromButton,
          updateRegion: this.updateRegion,
          updateShowOptions: this.updateShowOptions,
          updateSubRegions: this.updateSubRegions,

          applyFiltersText: this.applyFiltersText,
          applyFiltersToAPICall: this.applyFiltersToAPICall,
          clearAllFilters: this.clearAllFilters,
          clearFiltersText: this.clearFiltersText,
          enableSupplierFocusedSearch: this.enableSupplierFocusedSearch,
          noResultsPlaceholderText: "No results to display yet",
          noResultsText: this.noResultsText,
          removeFilterFromButton: this.removeFilterFromButton,
          resultsExplainerText: this.resultsExplainerText,
          resultsTab1Text: this.resultsTab1Text,
          resultsTab2Text: this.resultsTab2Text,

          // --store-- 
          culturalExperience: this.$store.state.culturalExperienceData,
          disableSubRegionDropdown: this.$store.state.disableSubRegionDropdown,
          filterSearchResponse: this.$store.state.filterSearchResponse,
          genders: this.$store.state.genderData,
          languages: this.$store.state.languageData,
          loading: this.$store.state.loading,
          locations: this.$store.state.locationData,
          message: this.$store.state.message,
          messageType: this.$store.state.messageType,
          optionalExpanded: this.$store.state.optionalExpanded,
          pagination: this.$store.state.pagination,
          paginationCurrentPage: this.$store.state.paginationCurrentPage,
          paginationShowNext: this.$store.state.paginationShowNext,
          selectedCulturalExperience: this.$store.state.selectedCulturalExpertise,
          selectedGenders: this.$store.state.selectedGender,
          selectedLanguages: this.$store.state.selectedLanguage,
          selectedRegion: this.$store.state.selectedRegion,
          selectedSubRegions: this.$store.state.selectedSubRegions,
          selectedTherapistExperience: this.$store.state.selectedExpertise.concat(this.$store.state.selectedCompetency),
          showNoResultsText: this.$store.state.showNoResultsText,
          showResultsCountText: this.$store.state.showResultsCountText,
          subRegionsForRegion: this.$store.state.subRegionsForRegion,
          therapistExperience: this.$store.state.therapistExperienceData,
        }
      });
    }
  });
}